module.exports = __webpack_public_path__ + "img/20_115.cb8e4527.png";